import {Entity} from "./Entity";
export const CreateEntity = `
    mutation createEntity ($input: CreateEntityInput!) {
        createEntity (input: $input) {
            ${Entity}
        }
    }
`
;